import {IdentityProjection} from '@scalified-monorepo/shared/domain';

export const GUEST_IDENTITY_EMAIL = 'Guest';

export const isAuthenticatedIdentity = (identity: IdentityProjection | null | undefined): boolean =>
  !!identity?.email && identity.email !== GUEST_IDENTITY_EMAIL;

export const guestIdentity = (): IdentityProjection => new IdentityProjection({email: GUEST_IDENTITY_EMAIL});
